import { useCallback, useState } from "react";

type SortDirection = "asc" | "desc";

export type SortState<TColumn extends string> = {
  column: TColumn;
  direction: SortDirection;
};

export function useSortState<TColumn extends string>(
  defaultState: SortState<TColumn>,
) {
  const [sortState, setSortState] = useState<SortState<TColumn>>(defaultState);
  const toggleSort = useCallback((column: TColumn) => {
    setSortState((current) =>
      current.column === column
        ? {
            column,
            direction: current.direction === "asc" ? "desc" : "asc",
          }
        : { column, direction: "asc" },
    );
  }, []);
  return { sortState, toggleSort };
}
